import React, { useEffect } from 'react';
import TopBlock from './blocks/top';
import CenteredButton from './blocks/centeredButton';
import LogosBlock from './blocks/logos';
import TextBlock from './blocks/text';
import CardsBlock from './blocks/cards';
import TableBlock from './blocks/table';
import PointsBlock from './blocks/points';
import ShowCase from './blocks/showcase';
import Accordion from './blocks/accordion';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Shop = () => {
  useEffect(() => {
    (window.dataLayer || []).push({
      event: 'page_view_business',
      page_name: 'shop',
    });
  }, []);

  return (
    <ShopContainer>
      <TopBlock />
      <CenteredButton />
      <LogosBlock />
      <TextBlock
        heading={
          <FormattedMessage
            id="shop.text.first.title"
            defaultMessage="С нами просто и быстро"
          />
        }
        text={
          <FormattedMessage
            id="shop.text.first"
            defaultMessage="Мы позаботились о том, чтобы вы занимались бизнесом, а не разработкой сайта!"
          />
        }
      />
      <CardsBlock />
      <TableBlock />
      <TextBlock
        heading={
          <FormattedMessage
            id="shop.text.second.title"
            defaultMessage="Дополнительные возможности для сайта"
          />
        }
        text={
          <FormattedMessage
            id="shop.text.second"
            defaultMessage="Мы рассматриваем предоставление дополнительных опций для сайтов клиентов. Конечная стоимость сайта определяется набором опций при составлении финального технического задания."
          />
        }
        half
      />
      <PointsBlock />
      <TextBlock
        heading={
          <FormattedMessage
            id="shop.text.third.title"
            defaultMessage="Наши клиенты"
          />
        }
        text={
          <FormattedMessage
            id="shop.text.third"
            defaultMessage="Мы открыли сотни сайтов, которые уже приносят заказы своим владельцам"
          />
        }
        smargin
      />
      <ShowCase />
      <TextBlock
        heading={
          <FormattedMessage
            id="shop.text.fourth.title"
            defaultMessage="Часто задаваемые вопросы"
          />
        }
      />
      <Accordion />
      <CenteredButton lmargin />
    </ShopContainer>
  );
};

const ShopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export default Shop;



// WEBPACK FOOTER //
// ./src/routes/Shop/index.js